<template>
  <div class="success">
    <img
      v-if="image"
      :src="image"
      :alt="altImage || title"
    />
    <h2
      v-if="title"
      class="title"
    >
      {{ title }}
    </h2>
    <div class="success__steps">
      <h3
        v-if="subtitle"
        class="title title--small"
      >
        {{ subtitle }}
      </h3>
      <ul>
        <li
          v-for="(step, index) in steps"
          :key="index"
        >
          <img
            v-if="step.icon"
            :src="step.icon"
            :alt="step.altIcon || step.text | stripHtml"
          />
          <p
            v-if="step.text"
            v-html="step.text"
          ></p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Success',
  filters: {
    stripHtml(value) {
      const div = document.createElement('div');
      div.innerHTML = value;
      const text = div.textContent || div.innerText || '';
      return text;
    },
  },
  props: {
    image: {
      type: String,
      default: '',
    },
    altImage: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    steps: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.success {
  max-width: 1046px;
  > img {
    display: block;
    margin: auto;
    max-width: 300px;
  }
  > h2 {
    text-transform: uppercase;
    text-align: center;
    max-width: 650px;
    margin: 35px auto 60px;
  }
  &__steps {
    padding: 30px;
    box-shadow: 2px 10px 20px rgba($lb-dark-gray, 0.15);
    border-radius: 5px;
    border: 1px solid rgba($lb-light-gray, 0.5);
    h3 {
      margin-bottom: 50px;
    }
    ul {
      padding: 10px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      li {
        flex: 0 1 calc(100% / 3);
        text-align: center;
        img {
          height: 55px;
          width: auto;
        }
        p {
          margin-top: 15px;
          font-size: $size-normal;
        }
      }
    }
  }
}
</style>
